// extracted by mini-css-extract-plugin
export default {"debug":"styles_debug__3FdfU","debug-container":"styles_debug-container__CiOnd","buttons":"styles_buttons__9eFX1","hyperlinks":"styles_hyperlinks__YlJRQ"};